import { render, staticRenderFns } from "./SaleSidebarDetails.vue?vue&type=template&id=92853900&"
import script from "./SaleSidebarDetails.vue?vue&type=script&lang=ts&"
export * from "./SaleSidebarDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports